import { render, staticRenderFns } from "./settingWrap.vue?vue&type=template&id=143d1589&"
import script from "./settingWrap.vue?vue&type=script&lang=js&"
export * from "./settingWrap.vue?vue&type=script&lang=js&"
import style0 from "./settingWrap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports